import { useRef, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import {
  mapSearchRefAtom,
  activeDatasetTabAtom,
  allDatasetAtoms,
  spatialFilterModeAtom,
} from '../atoms';
import { datasetRegistry } from '../datasets';

const payloadReplacer = (k: string, v: unknown) => {
  if (k === 'page' || k === 'pageSize') return undefined;
  if (v === '' || v === undefined || v === null) return undefined;
  return v;
};

export const FitBoundsOnSearch = () => {
  const activeTab = useAtomValue(activeDatasetTabAtom);
  const atoms = allDatasetAtoms[activeTab];
  const searchResult = useAtomValue(atoms.searchAtom);
  const mapRef = useAtomValue(mapSearchRefAtom);
  const spatialFilterMode = useAtomValue(spatialFilterModeAtom);
  const prevKeyRef = useRef<string>('');

  useEffect(() => {
    const bb = searchResult.data?.boundingBox;
    if (!bb?.points || !mapRef) return;

    // When using visible map extent, the bounds ARE the viewport — skip.
    if (spatialFilterMode === 'visible-extent') return;

    const payload = searchResult.currentPayload ?? {};
    const key = JSON.stringify(payload, payloadReplacer);

    // Skip when payload matches defaults (initial load / Clear All)
    const defaultKey = JSON.stringify(
      datasetRegistry[activeTab].defaultPayload,
      payloadReplacer
    );
    if (key === defaultKey) return;

    // Dedup so we don't re-zoom on page-only changes
    if (key === prevKeyRef.current) return;
    prevKeyRef.current = key;

    mapRef.fitBounds(bb.points, { padding: 100, duration: 1000, maxZoom: 16 });
  }, [searchResult.data, mapRef, spatialFilterMode, activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
